var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.resolvedUser)?_c('span',[(_vm.online !== null)?_c('span',{class:[_vm.online ? 'online-dot' : 'offline-dot']}):_vm._e(),_vm._v(" "+_vm._s(_vm.displayFullName ? _vm.fullName : _vm.resolvedUser.username))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }